import styles from './Register.module.css';

import { TextField, Button, Typography, Box } from '@mui/material';

import { useState } from 'react';
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';

import { useAuth } from '../../AuthContext';

export const Register = () => {
    const [ status, setStatus ] = useState('idle');
    const [ error, setError ] = useState(null);
    const [ formData, setFormData ] = useState({
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        password: '',
        confirmPassword: ''
    });

    const { auth } = useAuth();

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validateForm = () => {
        if (!formData.email.trim()) return 'Email is required';
        if (!formData.password) return 'Password is required';
        if (formData.password !== formData.confirmPassword) return 'Passwords do not match';
        if (formData.password.length < 6) return 'Password must be at least 6 characters';
        return null;
    };

    const handleRegister = async () => {
        const validationError = validateForm();

        if (validationError) {
            setError(validationError);
            return;
        }

        setStatus('loading');
        setError(null);

        try {
            const userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.password);

            await sendEmailVerification(userCredential.user);

            setStatus('success');
        } catch (err) {
            setError(err.message);
            setStatus('idle');
        }
    };

    return (
        <Box className={ styles.container } sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="h4" component="h2" gutterBottom>
                Complete Registration
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', maxWidth: 400, px: { xs: 2, sm: 0 } }}>
                <TextField
                    label="Email"
                    name="email"
                    type="email"
                    value={ formData.email }
                    onChange={ handleInputChange }
                    required
                    fullWidth
                />

                <TextField
                    label="Password"
                    name="password"
                    type="password"
                    value={ formData.password }
                    onChange={ handleInputChange }
                    required
                    fullWidth
                    inputProps={{ minLength: 6 }}
                />

                <TextField
                    label="Confirm Password"
                    name="confirmPassword"
                    type="password"
                    value={ formData.confirmPassword }
                    onChange={ handleInputChange }
                    required
                    fullWidth
                />

                { error && (
                    <Typography color="error" variant="body2">
                        { error }
                    </Typography>
                ) }

                { status === 'idle' && (
                    <Button
                        variant="contained"
                        onClick={ handleRegister }
                        fullWidth
                    >
                        Complete Registration
                    </Button>
                )}
            </Box>

            { status === 'success' && (
                <Box sx={{ mt: 2 }}>
                    <Typography variant="body1" color="success.main">
                        Registration successful!
                    </Typography>
                    <Typography variant="body2">
                        Please check your email for a verification link.
                    </Typography>
                    <Typography variant="body2">
                        After verifying, you can log in with your credentials.
                    </Typography>
                </Box>
            ) }
        </Box>
    );
};
